export default __webpack_public_path__ + "static/media/packet.d642c63f.svg";